import { TranslocoService } from '@jsverse/transloco';
import { Injectable } from '@angular/core';
import { LifeCycleReportDto, PackagingUnitReportDto } from 'src/app/data-transfer/entities/packaging-unit-entities/packaging-unit-report-dto';
import { ComponentMasterDataDependent, ComponentReportDependentDto, ComponentReportDto } from 'src/app/data-transfer/entities/component-entities/component-report-dto';
import { InclusionMap } from '../templates/report-template-wizard/report-template-wizard.component';
import { PackagingSystemFieldsDto, PackagingSystemReportDto } from 'src/app/data-transfer/entities/packaging-system-entities/packaging-system-report-dto';
export enum InclusionMapContentType {
  List,
  Table,
  TableList,
  DiagramPie,
  Image,
  Annex,
  Analysis
}

@Injectable({ providedIn: 'root' })
export class DtoToMapService {

  constructor(private translateService: TranslocoService) { }

  getPackagingSystemSpecMapFromDto(template: PackagingSystemReportDto): InclusionMap {
    template = PackagingSystemReportDto.updateRecyclingResultsField(template);
    const inclusionMap = {
      name: 'includeSpec', included: true,
      subitems: [
        {
          name: 'primarysystem', included: template.masterData != null,
          subitems: [
            //{ name: 'documents', included: template.documents, contentType: InclusionMapContentType.List },
            { name: 'packagingUnit', included: template.packagingUnit, contentType: InclusionMapContentType.Annex },
            { name: 'packagingUnitMainBody', included: template.packagingUnitMainBody, contentType: InclusionMapContentType.Annex },
            { name: 'packagingUnitClosure', included: template.packagingUnitClosure, contentType: InclusionMapContentType.Annex },
            { name: 'packagingUnitDecoration', included: template.packagingUnitDecoration, contentType: InclusionMapContentType.Annex },
            { name: 'packagingUnitInlay', included: template.packagingUnitInlay, contentType: InclusionMapContentType.Annex },
            { name: 'packagingUnitPackagingAid', included: template.packagingUnitPackagingAid, contentType: InclusionMapContentType.Annex },
            this.getMasterDataSubitem(template.masterData),
          ]
        },
        {
          name: 'secondsystem', included: template.subMasterData != null,
          subitems: [
            { name: 'subPackagingSystems', included: template.subPackagingSystems, contentType: InclusionMapContentType.Annex },
            { name: 'completeHierarchy', included: template.completeHierarchy, contentType: InclusionMapContentType.Annex },
            { name: 'subPackagingUnit', included: template.subPackagingUnit, contentType: InclusionMapContentType.Annex },
            { name: 'subPackagingUnitMainBody', included: template.subPackagingUnitMainBody, contentType: InclusionMapContentType.Annex },
            { name: 'subPackagingUnitClosure', included: template.subPackagingUnitClosure, contentType: InclusionMapContentType.Annex },
            { name: 'subPackagingUnitDecoration', included: template.subPackagingUnitDecoration, contentType: InclusionMapContentType.Annex },
            { name: 'subPackagingUnitInlay', included: template.subPackagingUnitInlay, contentType: InclusionMapContentType.Annex },
            { name: 'subPackagingUnitPackagingAid', included: template.subPackagingUnitPackagingAid, contentType: InclusionMapContentType.Annex },
            this.getMasterDataSubitem(template.subMasterData, undefined,undefined,'subMasterData')
          ]
        },
        {
          name: 'lifeCycleResult', included: template.lifeCycleResult != null,
          contentType: InclusionMapContentType.Analysis,
          subitems: [
            this.getLcaEffectsSubitem('table', template.lifeCycleResult),
            this.getLcaEffectsSubitem('lifeCycleStageDiagram', template.lifeCycleResult),
            {
              name: 'methodology', included: template.lifeCycleResult?.methodology,
              contentType: InclusionMapContentType.Annex
            }
          ]
        },
        {
          name: 'recyclabilityResult', included: template.recyclabilityResult,
          contentType: InclusionMapContentType.Analysis,
          subitems: [
            { name: 'countryOverview', included: template.countryOverview, contentType: InclusionMapContentType.Annex },
            { name: 'packagingSystemHierarchy', included: template.packagingSystemHierarchy, contentType: InclusionMapContentType.Annex },
            {
              name: 'recyclabilityChart', included: template.recyclabilityChart,
              contentType: InclusionMapContentType.DiagramPie
            },
            {
              name: 'showRecyclabilityMethodology', included: template.showRecyclabilityMethodology,
              contentType: InclusionMapContentType.Annex
            }
          ]
        }
      ]
    };
    this.setLabelsRecursively(inclusionMap);
    return inclusionMap;
  }

  getPackagingUnitSpecMapFromDto(template: PackagingUnitReportDto): InclusionMap {
    const inclusionMap = {
      name: 'includeSpec', included: true,
      subitems: [
        {
          name: 'primary', included: template.masterData != null,
          subitems: [
            { name: 'images', included: template.images, contentType: InclusionMapContentType.Image },
            { name: 'certificates', included: template.certificates, contentType: InclusionMapContentType.Annex },
            { name: 'documents', included: template.documents, contentType: InclusionMapContentType.Annex },
            { name: 'docAreaDocuments', included: template.docAreaDocuments, contentType: InclusionMapContentType.Annex },
            this.getMasterDataSubitem(template.masterData),
            { name: 'componentsSummary', included: template.componentsSummary, contentType: InclusionMapContentType.Table }
          ]
        },
        this.getPackagingComponentSubitem('mainBody', template),
        this.getPackagingComponentSubitem('closures', template),
        this.getPackagingComponentSubitem('decorations', template),
        this.getPackagingComponentSubitem('inlays', template),
        this.getPackagingComponentSubitem('packagingAids', template),
        {
          name: 'recyclabilityResult', included: template.recyclabilityResult != null,
          contentType: InclusionMapContentType.Analysis,
          subitems: [
            {
              name: 'diagram', included: template.recyclabilityResult?.diagram,
              contentType: InclusionMapContentType.DiagramPie
            },
            { name: 'ratingTable', included: template.recyclabilityResult?.ratingTable },
            { name: 'percentageTable', included: template.recyclabilityResult?.percentageTable },
            {
              name: 'methodology', included: template.recyclabilityResult?.methodology,
              contentType: InclusionMapContentType.Annex
            }
          ]
        },
        {
          name: 'lifeCycleResult', included: template.lifeCycleResult != null,
          contentType: InclusionMapContentType.Analysis,
          subitems: [
            this.getLcaEffectsSubitem('table', template.lifeCycleResult),
            this.getLcaEffectsSubitem('lifeCycleStageDiagram', template.lifeCycleResult),
            // this.getLcaEffectsSubitem('componentsDiagram', template.lifeCycleResult),
            {
              name: 'methodology', included: template.lifeCycleResult?.methodology,
              contentType: InclusionMapContentType.Annex
            }
          ]
        }
      ]
    };
    this.setLabelsRecursively(inclusionMap);
    return inclusionMap;
  }

  getComponentSpecMapFromDto(template: ComponentReportDto): InclusionMap {
    const inclusionMap = {
      name: 'includeSpecComponent', included: true,
      subitems: [
        {
          name: '', included: true,
          subitems: [
            { name: 'images', included: template.images, contentType: InclusionMapContentType.Image },
            this.getMasterDataSubitem(template.masterData, undefined, true),
            this.getMaterialTableSubitem(template?.multiMaterialTable),
            { name: 'certificates', included: template.certificates, contentType: InclusionMapContentType.Annex },
            { name: 'documents', included: template.documents, contentType: InclusionMapContentType.Annex },
            { name: 'docAreaDocuments', included: template.docAreaDocuments, contentType: InclusionMapContentType.Annex }
          ]
        }
      ]
    };
    this.setLabelsRecursively(inclusionMap);
    return inclusionMap;
  }

  private getPackagingComponentSubitem(componentName: string, template: PackagingUnitReportDto) {
    const defaultTemplate = new PackagingUnitReportDto(true);
    const templateComponent = template[componentName as keyof PackagingUnitReportDto] as ComponentReportDependentDto;
    return {
      name: componentName, included: templateComponent != null,
      subitems: [
        this.getMasterDataSubitem(templateComponent?.masterData, defaultTemplate.inlays.masterData),
        this.getMaterialTableSubitem(templateComponent?.multiMaterialTable)]
    };
  }

  private getMasterDataSubitem(masterData: any | null, fallback?: ComponentMasterDataDependent, isIndependentComponent?: boolean, name:string = 'masterData') {
    const transPath = 'fieldNamesForExport.';
    return {
      name: name,
      included: masterData != null,
      contentType: InclusionMapContentType.List,
      associatedObject: this.getFields(masterData ?? fallback, transPath, isIndependentComponent)
        // The DOC area documents are only attached for the primary packaging system, not for its sub systems.
        .filter(field => !(name === 'subMasterData' && field.name === 'docAreaDocuments'))
    };
  }

  private getMaterialTableSubitem(masterData: any | null) {
    return {
      name: 'multiMaterialTable',
      included: masterData != null,
      contentType: InclusionMapContentType.TableList
    };
  }

  private setLabelsRecursively(inclusionMap: InclusionMap) {
    if (inclusionMap.name !== '') {
      inclusionMap.label = this.translateService.translate('report.templateSection.' + inclusionMap.name);
    }
    if (inclusionMap.subitems) {
      for (const subitem of inclusionMap.subitems) {
        this.setLabelsRecursively(subitem);
      }
    }
  }

  private getLcaEffectsSubitem(name: string, lcaReport: LifeCycleReportDto) {
    const transPathAnalysis = 'analysis.lifecycleAnalysis.';
    const effects = lcaReport ? lcaReport[name as keyof LifeCycleReportDto] : null;
    return {
      name,
      included: effects != null,
      contentType: InclusionMapContentType.List,
      associatedObject: this.getFields(effects, transPathAnalysis)
    };
  }

  private getFields(
    object: any, translationPath: string, isIndependentComponent?: boolean
  ): { name: string, label: string, included: boolean }[] {
    if (!object) { return []; }
    const packagingFieldKeys = Object.getOwnPropertyNames(object);
    const packagingFieldValues: { name: string, label: string, included: boolean }[] = [];
    packagingFieldKeys.forEach(key => {
      let label: string;
      if (key === 'isRigidComponent' && isIndependentComponent) {
        label = this.translateService.translate(translationPath + 'isRigidComponentIndependent');
      } else if (key === 'documents') {
        // Same name as for the additional documents in the dataset editing
        label = this.translateService.translate('pdf.productPdfs');
      } else {
        label = this.translateService.translate(translationPath + key);
      }
      const included = object[key];
      packagingFieldValues.push({ name: key, label, included });
    });
    return packagingFieldValues;
  }
}
